import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';
import ImageModal from './../../components/ImageModal';


const TransomGlass = ({ value, onChange, label = 'Transom Glass', disabled = false, showPics = false }) => {
    const defaultColor = {
        value: value?.value || '#F8F8FF',
        label: value?.label || 'Clear',
      };
 

    const [selectedTransomGlass, setSelectedTransomGlass] = useState(defaultColor);
    const [showModal, setShowModal] = useState(false);


    const handleTransomGlassChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text;
    
        const newOption = { value: newValue, label: selectedText };
        setSelectedTransomGlass(newOption);
        onChange(newOption);

        //onChange({ value: newValue, label: selectedText.replace(' ✔', '') });
    };

    useEffect(() => {
        onChange(defaultColor);
    }, []); // only once on mount

    return (
        <div className="a-container">
            <label htmlFor="TransomGlass" disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled}
                id="TransomGlass"
                value={selectedTransomGlass.value}
                onChange={handleTransomGlassChange}
            >
                <option value="#F8F8FF">
                    {selectedTransomGlass.value === '#F8F8FF' ? 'Clear ✔' : 'Clear'}
                </option>
                <option value="#DCDCDC">
                    {selectedTransomGlass.value === '#DCDCDC' ? 'Sandblasted ✔' : 'Sandblasted'}
                </option>
                <option value="#E0E0E0">
                    {selectedTransomGlass.value === '#E0E0E0' ? 'Delta ✔' : 'Delta'}
                </option>
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/textures"
                imageName={selectedTransomGlass.label} // ✅ Now works!
                //width={400}
                //height={400}
            />
        </div>
    );
};

export default TransomGlass;
